import { render, staticRenderFns } from "./Orderlist.vue?vue&type=template&id=74fa14ca&scoped=true&"
import script from "./Orderlist.vue?vue&type=script&lang=js&"
export * from "./Orderlist.vue?vue&type=script&lang=js&"
import style0 from "./Orderlist.vue?vue&type=style&index=0&id=74fa14ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fa14ca",
  null
  
)

export default component.exports